export const getGrenacheFranceData = () => ({
  name: "Grenache",
  country: "France",
  description: "Le Grenache est principalement cultivé dans le sud de la France, particulièrement en Provence et dans le Rhône.",
  regions: [
    { name: "Côtes du Rhône", area: "3,500 ha", percentage: "40%", description: "Cépage principal" },
    { name: "Châteauneuf-du-Pape", area: "2,800 ha", percentage: "32%", description: "Assemblage traditionnel" },
    { name: "Provence", area: "1,500 ha", percentage: "17%", description: "Vins rosés" },
    { name: "Languedoc-Roussillon", area: "800 ha", percentage: "9%", description: "Usage limité" },
    { name: "Autres", area: "200 ha", percentage: "2%", description: "Dispersé dans le sud" }
  ],
  mapAreas: [
    { region: "Côtes du Rhône", x: 58, y: 55, color: "#4B164C", size: 6 },
    { region: "Châteauneuf-du-Pape", x: 57, y: 60, color: "#6d2c7a", size: 5 },
    { region: "Provence", x: 65, y: 70, color: "#8a4a8a", size: 4 },
    { region: "Languedoc-Roussillon", x: 50, y: 65, color: "#a768a6", size: 3 }
  ],
  subregions: {
    rhone: {
      name: "Rhône",
      description: "Le Grenache du Rhône est le cépage principal des vins rouges du sud, produisant des vins chaleureux et fruités.",
      characteristics: {
        aromas: "Fruits rouges mûrs, framboise, notes de garrigue, épices",
        body: "Corps moyen à plein",
        tannins: "Tannins doux et soyeux",
        aging: "Vieillissement moyen (8-15 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen chaud",
        soil: "Sols calcaires et galets roulés",
        viticulture: "Rendements modérés, vendanges tardives"
      },
      differentiators: [
        "Chaleur et générosité uniques",
        "Fruité intense et mûr",
        "Notes de garrigue caractéristiques",
        "Style chaleureux et accessible"
      ],
      foodPairing: "Viandes rouges, plats méditerranéens, fromages doux"
    }
  }
}); 